import { ClickEvent, TableRow } from "@mcleod/components";
import { AutogenLayoutCarrierPlan } from "@mcleod/crm/src/autogen/AutogenLayoutCarrierPlan";
import { CarrierPlanDetail } from "./CarrierPlanDetail";
import { DuplicateId, DuplicateIdProps } from "@mcleod/dispatch";

const viewCarrierPlanUrl = "lme/crm/CarrierPlan?mode=update&key=";

const DUPLICATE_VALIDATION_PROPS: DuplicateIdProps = {
    tableName: "market_plan",
    screenName: "Carrier Plan",
    navigateToUrl: viewCarrierPlanUrl,
    compositeKeyValues: {
        "type_of": "A"
    }
};

export class CarrierPlan extends AutogenLayoutCarrierPlan {

    onLoad(): void | Promise<void> {
        DuplicateId.configureIdTextbox(this.textboxId, DUPLICATE_VALIDATION_PROPS);
    }

    tableCarrierPlanDetailOnDblClick(event: ClickEvent) {
        const tableRow = event.target as TableRow;
        tableRow.showEditLayout();
    }

    buttonAddActivityOnClick(event: ClickEvent) {
        CarrierPlanDetail.showAdd({
            onSave: (updatedRow) => {
                updatedRow.set('mark_plan_id', this.activeRow.get('id'));
                this.tableCarrierPlanDetail.addRow(updatedRow, null, { display: true, addToData: true });
            }
        });
    }

    tableCarrierPlanDetailBeforeRowSave(event: ClickEvent) {
        const tableRow = event.target as TableRow;
        if (tableRow.data) {
            if (tableRow.data.isNull('type_of')) {
                tableRow.data.set('type_of', 'A');
            }
            if (tableRow.data.isNull('def_assign')) {
                tableRow.data.set('def_assign', 'O');
            }
            if (tableRow.data.isNull('mark_plan_id')) {
                tableRow.data.set('mark_plan_id', this.activeRow.get('id'));
            }           
        }
    }

}